const handleErrorMessage = (error) => {
    if(error){
        return typeof error == 'object' && 
        error !== null &&
        !Array.isArray(error)
        ? error.error || error.msg : error
    }
}

export default handleErrorMessage